module.exports = "//public.getcloudapp.com/packs/media/images/enterprise@2x-c79fb740021d199364e5adb8570b2d65.png";